export default __webpack_public_path__ + "static/media/12-32-14 3.ce3663df.jpg";